// Personal calendar subscription links (20260918100000_calendar_links.sql).
//
// Only a hash of the token is stored, so a link can be shown once — when it is
// made — and never again. Reset makes a new one and kills the old in the same
// statement. The feed itself is the calendar-feed Edge Function.
import { supabase } from './supabase';
import { env } from './env';

type DbError = { message: string } | null;

export const feedUrl = (token: string) =>
  `${env.supabaseUrl}/functions/v1/calendar-feed/${token}.ics`;

/** When the caller's current link was made (at: null — they have none). An
 *  error is not "none": offering Create then would silently kill their link. */
export async function linkCreatedAt(): Promise<{ at: string | null; error: DbError }> {
  if (!supabase) return { at: null, error: { message: 'Not connected.' } };
  const { data, error } = await supabase.rpc('calendar_link_created_at');
  return { at: (data as string | null) ?? null, error };
}

/** A new link for the caller; any previous one stops working at once. */
export async function resetLink(): Promise<{ url: string | null; error: DbError }> {
  if (!supabase) return { url: null, error: { message: 'Not connected.' } };
  const { data, error } = await supabase.rpc('reset_calendar_link');
  return { url: data ? feedUrl(data as string) : null, error };
}

/** Deletes every link (org:full) — for a leak, where off-then-on would revive it. */
export async function revokeAllLinks(): Promise<{ error: DbError }> {
  if (!supabase) return { error: { message: 'Not connected.' } };
  const { error } = await supabase.rpc('revoke_calendar_links');
  return { error };
}
